<template>
  <div class="attendee-filter">
    <div class="filter-body">
      <div v-if="!hideSearch" class="filter-body__item">
        <c-input
          label="Search"
          v-model="filters.search"
          @input="handleFilterChange"
        />
      </div>

      <div
        v-if="filters?.days?.length > 1"
        class="filter-body__item"
      >
        <custom-checkbox-group
          label="Days"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.days"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, color, index }"
        >
          <MarkedStatus
            :withBorder="true"
            :isChecked="is_checked"
            :markerColor="'#bcbcbc'"
          >{{ name }}</MarkedStatus>
        </custom-checkbox-group>
      </div>

      <div class="filter-body__item" >
<!--        v-if="cachedFilters.timeframe"-->
        <AgendaFilterTimestamp
          v-if="filters.timeframe"
          :startTime="timeframeBounds[0]"
          :endTime="timeframeBounds[1]"
          @change="handleFilterChange"
          v-model="filters.timeframe"/>
      </div>

      <div
        v-if="filters?.statuses?.length"
        class="filter-body__item"
      >
        <custom-checkbox-group
          label="Statuses"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.statuses"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, color, index }"
        >
          <MarkedStatus
            :withBorder="true"
            :isChecked="is_checked"
            :markerColor="'#bcbcbc'"
          >{{ name }}</MarkedStatus>
        </custom-checkbox-group>
      </div>

      <div
        v-if="filters?.tracks?.length"
        class="filter-body__item"
      >
        <custom-checkbox-group
          label="Tracks"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.tracks"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, color }"
        >
          <MarkedStatus
            :withBorder="true"
            :isChecked="is_checked"
            :markerColor="color"
          >{{ name }}</MarkedStatus>
        </custom-checkbox-group>
      </div>

      <div
        v-if="filters?.visiting_types?.length > 1"
        class="filter-body__item"
      >
        <custom-checkbox-group
          label="Visiting types"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.visiting_types"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, color, index }"
        >
          <MarkedStatus
            :withBorder="true"
            :isChecked="is_checked"
            :markerColor="'#bcbcbc'"
          >{{ name }}</MarkedStatus>
        </custom-checkbox-group>
      </div>

      <div
        v-if="filters?.types?.length > 1"
        class="filter-body__item"
      >
        <custom-checkbox-group
          :label="`${conferenceId === 7007 ? 'CE Types' : 'Types'}`"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.types"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, color, index }"
        >
          <MarkedStatus
            :withBorder="true"
            :isChecked="is_checked"
            :markerColor="'#bcbcbc'"
          >{{ name }}</MarkedStatus>
        </custom-checkbox-group>
      </div>

      <div
        v-if="filters?.topics?.length"
        class="filter-body__item"
      >
        <custom-checkbox-group
          :label="`${conferenceId === 7007 ? 'Specialty CE Topics' : 'Topics'}`"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.topics"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, color, index }"
        >
          <MarkedStatus
            :withBorder="true"
            :isChecked="is_checked"
            :markerColor="'#bcbcbc'"
          >{{ name }}</MarkedStatus>
        </custom-checkbox-group>
      </div>

<!--      <div class="filter-body__item" v-if="filters?.rooms?.length">-->
<!--        <custom-checkbox-group-->
<!--          label="Rooms"-->
<!--          label-key="name"-->
<!--          checked-key="is_checked"-->
<!--          v-model="filterResult.rooms"-->
<!--          :options="filters.rooms"-->
<!--          @input="handleFilterChange"-->
<!--          v-slot="{ name, is_checked, color, index }"-->
<!--        >-->
<!--          <MarkedStatus-->
<!--            :withBorder="true"-->
<!--            :isChecked="is_checked"-->
<!--            :markerColor="'#bcbcbc'"-->
<!--          >{{ name }}</MarkedStatus>-->
<!--        </custom-checkbox-group>-->
<!--      </div>-->

      <div
        v-if="filters?.my_presentations?.length"
        class="filter-body__item"
      >
        <custom-checkbox-group
          label="Presentations"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.my_presentations"
          :options="filters.my_presentations"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, color, index }"
        >
          <MarkedStatus
            :withBorder="true"
            :isChecked="is_checked"
            :markerColor="'#bcbcbc'"
          >{{ name }}</MarkedStatus>
        </custom-checkbox-group>
      </div>

      <div
        v-if="filters?.formats?.length"
        class="filter-body__item"
      >
        <custom-checkbox-group
          label="Formats"
          label-key="name"
          checked-key="is_checked"
          v-model="filters.formats"
          @input="handleFilterChange"
          v-slot="{ name, is_checked, color, index }"
        >
          <MarkedStatus
            :withBorder="true"
            :isChecked="is_checked"
            :markerColor="'#bcbcbc'"
          >{{ name }}</MarkedStatus>
        </custom-checkbox-group>
      </div>
    </div>

    <div class="filter-footer"></div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import MarkedStatus from "../ui/MarkedStatus";
import CustomCheckboxGroup from "../ui/form/custom-checkbox-group";
import AgendaFilterTimestamp from "./agenda-filter-timestamp";

export default {
  components: {
    AgendaFilterTimestamp,
    MarkedStatus,
    CustomCheckboxGroup,
  },
  data() {
    return {};
  },
  props: {
    filters: {
      type: Object,
      default: () => ({
        search: '',
        days: [],
        formats: [],
        rooms: [],
        topics: [],
        tracks: [],
        types: [],
        visiting_types: [],
        statuses: [],
        // timeframe: ['11:00 AM', '06:00 PM'],
        timeframe: [],
        my_presentations: [],
      }),
    },
    hideSearch: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters('attendeeStore', [
      'conferenceId',
    ]),

    ...mapGetters('agendaStore', [
      'cachedFilters',
    ]),

    timeframeBounds() {
      const bounds = this.cachedFilters?.timeframe;
      if (Array.isArray(bounds) && bounds.length === 2 && bounds[0] && bounds[1]) {
        return bounds;
      }
      return ['01:00 AM', '11:00 PM'];
    },
  },
  methods: {
    handleFilterChange() {
      this.$emit('filter', this.filters);
    },
  }
};
</script>

<style lang="scss" scoped>
.filter-body__item {
  margin-bottom: var(--attendee-gap-md);

  label {
    color: var(--attendee-text-secondary-color);
    font-size: 16px;
    font-weight: 400;
  }
}
</style>
